import React, { useEffect, useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import {
    DialogTitle,
    Paper,
    Grid,
    Button,
    ExpansionPanelDetails,
    Dialog,
    DialogContent,
    DialogActions,
    IconButton,
    InputAdornment,
    List,
    Card,
    CardContent,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    LinearProgress
} from '@material-ui/core';
import { PartyIncomeReportCss as useStyles } from './ReportSideBarCss';
import RightSideBar from '../RightSideBar/RightSideBar';
import { getAllPnlMonths } from '../../../store/actions/homeActionCreator';
import { fetchPartyIncomeReport, getPartyIncomeExcel, getMonthlyBalancesPartyForReports } from '../../../store/actions/partiesActionCreator';
import MUIDataTable from "mui-datatables";
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import FilterComponent from '../FilterComponent/FilterComponent';
import * as logger from '../../../logger';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { numberFormat } from '../../../utils/utils';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ReportsDialog from '../ReportsDialog/ReportsDialog';
import AddIcon from '@material-ui/icons/Add';
import InfoDialog from '../Dialog/InfoDialog';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { trackDwebEvent } from '../../analytics';

const PartyIncomeReport = ({ user, trip, parties, open, onClose, dispatchGetPnlMonths, dispatchFetchPartyIncomeReport, dispatchGetPartyIncomeExcel, vehicle, dispatchGetSinglePartyMonthlyBalances, handleAddTrip }) => {

    const [dialogOpen, setDialogOpen] = useState(open);
    const [showExcelDownloadButton, setShowExcelDownloadButton] = useState(false);
    const [dateFilterValue, setDateFilterValue] = useState("");
    const [changeDataFlag, setChangeDataFlag] = useState(false);
    const [montlyReport, setMontlyReport] = useState(false);
    const [vehicleNumber, setVehicleNumber] = useState([]);
    const [partyReportData, setPartyReportData] = useState({});
    const [partyList, setPartyList] = useState([]);
    const [singlePartyBalance, setSinglePartyBalance] = useState({});
    const [collapseKeys, setCollapseKeys] = useState({});
    const [pdfOpen, setPdfOpen] = useState(false);
    const [partyName, setPartyName] = useState("");
    const [partyId, setPartyId] = useState("");
    const [pdfMonthValue, setPdfMonthValue] = useState("");
    const [title, setTitle] = useState("Party Revenue Report");
    const [infoOpen, setInfoOpen] = useState(false);
    const [infoTitle, setInfoTitle] = useState("");
    const [infoText, setInfoText] = useState("");

    const classes = useStyles();

    const getMuiTheme = (type) => createMuiTheme({
        overrides: {
            MUIDataTableBodyCell: {
                root: {
                    backgroundColor: "#FF0000"
                }
            },
            MuiList: {
                padding: {
                    paddingTop: 0,
                    paddingBottom: 0
                }
            },
            MUIDataTable: {
                paper: {
                    //padding:24
                    boxShadow: 'inset 0 -1px 0 0 #e1e1e1',
                    borderRadius: '6px !important',
                },
                responsiveBase: {
                    border: '1px solid #dfe2e5',
                    borderRadius: 6,
                    //maxHeight: 'calc(100vh - 370px) !important',
                    //height: 'auto !important'
                }
            },
            MUIDataTableHead: {
            },
            MUIDataTableBodyRow: {
                root: {
                    height: 42,
                    maxHeight: 42,
                    minHeight: 42,
                    fontWeight: 300,
                    cursor: 'pointer',
                    '&:nth-of-type(even)': {
                        backgroundColor: '#f6f6f8',
                    },
                    '&:last-child': {
                        cursor: 'default',
                        backgroundColor: '#00875a',
                        '&:hover': {
                            backgroundColor: '#00875a',
                        }
                    }
                }
            },
            MUIDataTableSelectCell: {
                fixedHeader: {
                    backgroundColor: "#f1f1f3"
                },
                headerCell: {
                    backgroundColor: "#f1f1f3"
                }
            },
            MUIDataTableHeadCell: {
                root: {
                    backgroundColor: "#f1f1f3",
                    fontWeight: 'bold',
                    textAlign: 'end',
                    '&:first-child': {
                        textAlign: 'start'
                    }
                },
                sortLabelRoot: {
                    height: 'auto'
                },
                fixedHeader: {
                    backgroundColor: "#d7dfe5",
                    paddingBottom: 10,
                    paddingTop: 10,
                    top: -1
                }
            },
            MUIDataTableBodyCell: {
                root: {
                    fontWeight: 'bold',
                    color: '#161f34'
                },
                stackedParent: {
                    borderTop: 'none',
                    paddingTop: 8,
                    paddingBottom: 8,
                    textAlign: 'end',
                    '&:first-child': {
                        textAlign: 'start'
                    },
                    '&:last-child': {
                        paddingLeft: '2px !important',
                        paddingRight: '8px !important',
                        width: 17,
                        maxWidth: 17
                    }
                }
            },
        }
    })

    useEffect(() => {

        dispatchGetPnlMonths(
            (data) => {
                // if (data && data.status && data.status.code == 200) {
                logger.log("Party Income Report Dweb", 'Get PNL months successfull');

                const filterValue = {
                    monthYear: data && data.response && data.response.months && data.response.months[0] ? data.response.months[0] : ""
                };

                trackDwebEvent("Dweb Party Income Report", {
                    default_month: data && data.response && data.response.months && data.response.months[0] ? data.response.months[0] : ""
                });

                setDateFilterValue(data && data.response && data.response.months && data.response.months[0] ? data.response.months[0] : "");

                dispatchFetchPartyIncomeReport(filterValue,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log("Party Income Report Dweb", "Get Party Income Report Successfull");
                        }
                    },
                    () => {
                        logger.log("Party Income Report Dweb", "Get Party Income Report Failed");
                    }
                );
                // }
            },
            () => {
                logger.log("Party Income Report Dweb", 'Get PNL months failed');
            }
        );

    }, [open]);


    useEffect(() => {

        if (parties && parties.partyIncomeReport) {

            setPartyReportData(parties.partyIncomeReport);

            if (parties.partyIncomeReport && parties.partyIncomeReport.parties) {
                parties.partyIncomeReport.parties.push({
                    name: "Total",
                    amount: parties.partyIncomeReport.overallIncome ? parties.partyIncomeReport.overallIncome : "",
                    tripCount: parties.partyIncomeReport.overallTripCount ? parties.partyIncomeReport.overallTripCount : ""
                })

                setPartyList(parties.partyIncomeReport.parties);
            }

            if (parties.partyIncomeReport.emptyStateTitle) {
                setShowExcelDownloadButton(false);
            } else {
                setShowExcelDownloadButton(true);
            }

        }

    }, [parties.partyIncomeReport]);

    useEffect(() => {

        if (changeDataFlag) {
            const filterValue = {
                monthYear: dateFilterValue ? dateFilterValue : ""
            };

            dispatchFetchPartyIncomeReport(filterValue,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Truck Income Report Dweb", "Get Truck Income Report Successfull");
                    }
                },
                () => {
                    logger.log("Truck Income Report Dweb", "Get Truck Income Report Failed");
                }
            );
        }

    }, [dateFilterValue]);

    useEffect(() => {

        if (parties && parties.singlePartyMonthlyBalancesReports) {
            setSinglePartyBalance(parties.singlePartyMonthlyBalancesReports);
        }

    }, [parties.singlePartyMonthlyBalancesReports]);

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
        setPartyReportData({});
        parties.partyIncomeReport = {}
    }

    const handleDownloadExcel = () => {

        let monthYear;
        if (dateFilterValue) {
            monthYear = dateFilterValue;
        } else {
            monthYear = user && user.pnlMonths && user.pnlMonths[0] ? user.pnlMonths[0] : "";
        }

        dispatchGetPartyIncomeExcel(monthYear,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Party Income Report Dweb", "Get Excel link successfull");
                    if (data && data.response && data.response.s3Link) {
                        window.open(data.response.s3Link);
                        trackDwebEvent("Dweb Party Income Report Excel Download", {
                            default_month: monthYear
                        });
                    }
                }
            },
            () => {
                logger.log("Party Income Report Dweb", "Get Excel link failed");
            }
        )

    }

    const handleBackClick = () => {
        dispatchGetPnlMonths(
            (data) => {
                // if (data && data.status && data.status.code == 200) {
                logger.log("Truck Income Report Dweb", 'Get PNL months successfull');

                const filterValue = {
                    monthYear: dateFilterValue ? dateFilterValue : ""
                };

                dispatchFetchPartyIncomeReport(filterValue,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log("Truck Income Report Dweb", "Get Truck Income Report Successfull");
                            setShowExcelDownloadButton(true);
                            setMontlyReport(false);
                            setTitle("Party Revenue Report");
                        }
                    },
                    () => {
                        logger.log("Truck Income Report Dweb", "Get Truck Income Report Failed");
                    }
                );
                // }
            },
            () => {
                logger.log("Truck Income Report Dweb", 'Get PNL months failed');
            }
        );
    }

    const handlePnlDate = (dateValue) => {
        setDateFilterValue(dateValue);
        setChangeDataFlag(true);
    }

    const muiData = partyList ? partyList : [];

    const muiColumns = [
        {
            name: "name",
            label: "Party Name",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const partyName = muiData && muiData[dataIndex] && muiData[dataIndex].name ? muiData[dataIndex].name : ""
                    return (
                        <>
                            <div className={partyName == "Total" ? classes.divColorWhite : classes.fwNormal} >
                                {muiData && muiData[dataIndex] && muiData[dataIndex].name ? muiData[dataIndex].name : ""}
                            </div>
                        </>
                    );
                }
            },
        },
        {
            name: "tripCount",
            label: "Trips",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const partyName = muiData && muiData[dataIndex] && muiData[dataIndex].name ? muiData[dataIndex].name : ""
                    return (
                        <>
                            <div className={partyName == "Total" ? classes.divColorWhite : classes.fwNormal}>
                                {muiData && muiData[dataIndex] && muiData[dataIndex].tripCount ? muiData[dataIndex].tripCount : 0}
                            </div>
                        </>
                    );
                }
            },
        },
        {
            name: "amount",
            label: "Months' Income",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const partyName = muiData && muiData[dataIndex] && muiData[dataIndex].name ? muiData[dataIndex].name : ""
                    return (
                        <>
                            <div className={partyName == "Total" ? classes.divColorWhite : classes.fwBold}>
                                {muiData && muiData[dataIndex] && muiData[dataIndex].amount ? numberFormat(muiData[dataIndex].amount) : 0}
                            </div>
                        </>
                    );
                }
            },
        },
        {
            name: "",
            label: "",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <>
                            <div>
                                {muiData && muiData[dataIndex] && muiData[dataIndex].name && muiData[dataIndex].name != "Total" &&
                                    <KeyboardArrowRightIcon className={classes.arrowIcon} />
                                }
                            </div>
                        </>
                    );
                }
            },
        }
    ];

    const options = {
        filterType: "multiselect",
        selectableRows: 'none',
        searchOpen: false,
        search: false,
        sort: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        viewColumns: false,
        pagination: false,
        onRowClick: (rowData, rowMeta) => {
            handleRowClick(muiData[rowMeta.dataIndex])
        },
    }

    const handleRowClick = (partyData) => {
        if (partyData && partyData.id) {
            setTitle("Monthly Balance");
            setPartyName(partyData.name);
            setPartyId(partyData.id);
            dispatchGetSinglePartyMonthlyBalances(partyData.id,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('Party Income Report Dweb', 'Get Single Party Monthly Balances Successfull');
                        setMontlyReport(true);
                        setShowExcelDownloadButton(false);
                        trackDwebEvent("Dweb Party Income Report Party selected", {
                            party_id: partyData.id, 
                            party_name: partyData.name, 
                            party_contact_number: partyData.contactNumber ? partyData.contactNumber : ""
                        });
                    }
                },
                () => {
                    logger.log('Party Income Report Dweb', 'Get Single Party Monthly Balances Failed');
                }
            )
        }
    }

    const handleViewPdf = (partyData) => {
        setPdfOpen(true);
        setPdfMonthValue(partyData.name);
    }

    const handleClosePdf = () => {
        setPdfOpen(false);
    }

    const handleCollapseClick = (key) => {
        setCollapseKeys({ [key]: collapseKeys[key] ? false : true });
    }

    const handleInfoClick = (infoType) => {

        if (infoType == "Trip Started") {
            setInfoOpen(true);
            setInfoTitle(infoType);
            setInfoText("Total number of trips started during this month");
        } else if (infoType == "Trip Settled") {
            setInfoOpen(true);
            setInfoTitle(infoType);
            setInfoText("Total number of settled trips started during this month");
        }

    }

    const handleInfoClose = () => {
        setInfoOpen(false);
        setInfoTitle("");
        setInfoText("");
    }


    return (
        <>
            {open && <RightSideBar
                rightSideBarOpen={dialogOpen}
                sideBarTitle={title}
                sideBarType="reports"
                handleSubmit={event => handleDownloadExcel(event)}
                toggleRightSideBar={handleClose}
                showDownloadExcel={showExcelDownloadButton}
                backClick={handleBackClick}
                showBackReports={montlyReport}
                partyNameValue={partyName}
                fromPartyIncomeReport={montlyReport}
                titleType="reports"
            >
                <>
                    {!montlyReport &&
                        <div className={classes.divFilter}>
                            <FilterComponent reportType={"Party Income Report"} pnlDate={handlePnlDate} defaultValue={dateFilterValue} />
                        </div>
                    }
                    {!montlyReport &&
                        <>
                            {partyReportData && partyReportData.emptyStateTitle &&
                                <div className={classes.divEmptyState}>
                                    <div>
                                        <img src={partyReportData.icon} className={classes.imgV1}>
                                        </img>
                                    </div>
                                    <div className={classes.divEmptyText}>
                                        {partyReportData.emptyStateTitle}
                                    </div>
                                    <div>
                                        <Button variant="contained" className={classes.addTripButton} onClick={handleAddTrip} >
                                            <AddIcon />
                                            <span>
                                                Add Trip
                                            </span>
                                        </Button>
                                    </div>
                                </div>
                            }

                            {partyReportData && !partyReportData.emptyStateTitle &&
                                <div>
                                    {partyList && partyList.length > 0 &&
                                        <div className={classes.mtV1}>
                                            <MuiThemeProvider theme={getMuiTheme()}>
                                                <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
                                            </MuiThemeProvider>
                                        </div>
                                    }
                                </div>
                            }
                        </>
                    }

                    {montlyReport &&
                        <div className={classes.divMonthlyReport}>
                            {singlePartyBalance && singlePartyBalance.monthlyBalance && singlePartyBalance.monthlyBalance.length > 0 && singlePartyBalance.monthlyBalance.map((data, key) => (
                                < div style={{ marginBottom: 34 }}>
                                    <div className={classes.divAlign}>
                                        <div className={classes.divMonth}>{data.name}</div>
                                        <div className={classes.divPdf} onClick={() => handleViewPdf(data)}>
                                            <div className={classes.mrV1}><PictureAsPdfIcon /></div>
                                            <div>View PDF</div>
                                        </div>
                                    </div>
                                    <Card className={classes.cardV1}>
                                        <CardContent className={classes.cardContentV1}>
                                            <>
                                                {data && data.text &&
                                                    <div className={classes.divTextV1}>{data.text + ' for ' + data.name}</div>
                                                }
                                                {data && !data.text &&
                                                    <>
                                                        <div style={{ display: 'flex' }}>
                                                            <div>
                                                                <div className={classes.divTitleV2}>Trip Started
                                                                <InfoOutlinedIcon className={classes.infoIcon} onClick={() => handleInfoClick('Trip Started')} />
                                                                </div>
                                                                <div className={classes.divValue}>{data.numberOfTripsStarted == 1 ? data.numberOfTripsStarted + ' Trip' : data.numberOfTripsStarted + " Trips"}</div>
                                                            </div>
                                                            <div className={classes.divV1}>
                                                                <div className={classes.divTitleV2}>Trips Settled
                                                                <InfoOutlinedIcon className={classes.infoIcon} onClick={() => handleInfoClick('Trip Settled')} />
                                                                </div>
                                                                <div className={classes.divValue}>{data.numberOfTripsSettled == 1 ? data.numberOfTripsSettled + ' Trip' : data.numberOfTripsSettled + " Trips"}</div>
                                                            </div>
                                                        </div>

                                                        <div className={classes.divCollectionContainer}>
                                                            <div className={data.collectionPercentage == 0 ? classes.divCollectionZero : classes.divCollection} >
                                                                Collection&nbsp;{data.collectionPercentage}%
                                                            </div>
                                                            <div className={classes.mtV2}>
                                                                <LinearProgress variant="determinate" value={data.collectionPercentage} className={classes.linearProgress} classes={{ barColorPrimary: data.collectionPercentage == 100 ? classes.barColorV2 : classes.barColorV1 }} />
                                                            </div>
                                                        </div>

                                                        <hr className={classes.hrV1} />

                                                        <div>
                                                            {data.revenueItems && data.revenueItems.length == 0 &&
                                                                <div className={classes.divAlign}>
                                                                    <div className={classes.divTitleV3}>Revenue</div>
                                                                    <div className={classes.divValueV1}>{numberFormat(data.totalRevenue)}</div>
                                                                </div>
                                                            }
                                                            {data.revenueItems && data.revenueItems.length > 0 &&
                                                                <Accordion classes={{ root: classes.boxShadow }} onChange={() => handleCollapseClick(`revenue${key}collapse`)}>
                                                                    <AccordionSummary
                                                                        aria-controls="panel1a-content"
                                                                        id="panel1a-header"
                                                                        classes={{ content: classes.divCenter, root: classes.rootV1 }}
                                                                    >
                                                                        <div className={classes.divAlignV1}>
                                                                            <div className={classes.dFlex}>
                                                                                <div className={classes.divTitleV3}>Revenue</div>
                                                                                {collapseKeys && collapseKeys[`revenue${key}collapse`] ?
                                                                                    <ArrowDropUpIcon className={classes.arrowUpV1} />
                                                                                    :
                                                                                    <ArrowDropDownIcon className={classes.arrowDownV1} />
                                                                                }
                                                                            </div>
                                                                            <div className={classes.divValueV1}>{numberFormat(data.totalRevenue)}</div>
                                                                        </div>
                                                                    </AccordionSummary>
                                                                    <AccordionDetails classes={{ root: classes.pdV1 }}>
                                                                        <div className={classes.divItems}>
                                                                            {data.revenueItems.map((revenue) => (
                                                                                <div className={classes.divItemsV1}>
                                                                                    <div className={classes.divAlignV2}>
                                                                                        <div className={classes.divAlignV3}>
                                                                                            <div className={classes.fwbold}>{revenue.startDate}</div>
                                                                                            <span className={classes.bullet}>•</span>
                                                                                            <div>{revenue.startLocation}&nbsp;-&nbsp;{revenue.destinationLocation} </div>
                                                                                        </div>
                                                                                        <div>{numberFormat(revenue.amount)}</div>
                                                                                    </div>
                                                                                </div>
                                                                            ))
                                                                            }
                                                                        </div>
                                                                    </AccordionDetails>
                                                                </Accordion>
                                                            }
                                                        </div>

                                                        <div className={classes.mtV11}>
                                                            {data.paymentItems && data.paymentItems.length == 0 &&
                                                                <div className={classes.divAlign}>
                                                                    <div className={classes.divTitleV3}>Payments</div>
                                                                    <div className={classes.fwbold}>{numberFormat(data.totalPayment)}</div>
                                                                </div>
                                                            }
                                                            {data.paymentItems && data.paymentItems.length > 0 &&
                                                                <Accordion classes={{ root: classes.boxShadow }} onChange={() => handleCollapseClick(`expenses${key}collapse`)}>
                                                                    <AccordionSummary
                                                                        aria-controls="panel1a-content"
                                                                        id="panel1a-header"
                                                                        classes={{ content: classes.divCenter, root: classes.rootV1 }}
                                                                    >
                                                                        <div className={classes.divAlignV1}>
                                                                            <div className={classes.dFlex}>
                                                                                <div className={classes.divTitleV3}>Payments</div>
                                                                                {collapseKeys && collapseKeys[`expenses${key}collapse`] ?
                                                                                    <ArrowDropUpIcon className={classes.arrowUpV1} />
                                                                                    :
                                                                                    <ArrowDropDownIcon className={classes.arrowDownV1} />
                                                                                }
                                                                            </div>
                                                                            <div className={classes.fwbold}>{numberFormat(data.totalPayment)}</div>
                                                                        </div>
                                                                    </AccordionSummary>
                                                                    <AccordionDetails classes={{ root: classes.pdV1 }}>
                                                                        <div className={classes.divItems}>
                                                                            {data.paymentItems.map((payments) => (
                                                                                <div className={classes.divItemsV1}>
                                                                                    <div className={classes.divAlignV2}>
                                                                                        <div className={classes.divAlignV3}>
                                                                                            <div className={classes.fwbold}>{payments.startDate}</div>
                                                                                            <span className={classes.bullet}>•</span>
                                                                                            <div>{payments.startLocation}&nbsp;-&nbsp;{payments.destinationLocation} </div>
                                                                                        </div>
                                                                                        <div>{numberFormat(payments.amount)}</div>
                                                                                    </div>
                                                                                </div>
                                                                            ))
                                                                            }
                                                                        </div>
                                                                    </AccordionDetails>
                                                                </Accordion>
                                                            }
                                                        </div>

                                                        <hr className={classes.colorV2} />

                                                        <div className={classes.divAlign}>
                                                            <div className={classes.divProfit}>Balance</div>
                                                            <div className={data.balance > 0 ? classes.profit : classes.divBalance}>{numberFormat(data.balance)}</div>
                                                        </div>
                                                    </>
                                                }
                                            </>
                                        </CardContent>
                                    </Card>
                                </div>
                            ))
                            }
                        </div>
                    }
                </>
            </RightSideBar>}

            {pdfOpen &&
                <ReportsDialog open={pdfOpen} name={partyName} fromPartyIncomeReport={true} partyIdFromPartyIncomeReport={partyId} onClose={handleClosePdf} reportType={"excelReports"} pdfMonth={pdfMonthValue}/>
            }
            {infoOpen && <InfoDialog confirmOpen={infoOpen} confirmTitle={infoTitle} confirmMessage={infoText} onClose={handleInfoClose} />}

        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchGetPnlMonths: (onSuccess, onError) => {
        dispatch(getAllPnlMonths(null, onSuccess, onError))
    },
    dispatchFetchPartyIncomeReport: (filterData, onSuccess, onError) => {
        dispatch(fetchPartyIncomeReport(filterData, onSuccess, onError))
    },
    dispatchGetPartyIncomeExcel: (filterData, onSuccess, onError) => {
        dispatch(getPartyIncomeExcel(filterData, onSuccess, onError))
    },
    dispatchGetSinglePartyMonthlyBalances: (requestData, onSuccess, onError) => {
        dispatch(
            getMonthlyBalancesPartyForReports(
                requestData,
                onSuccess,
                onError
            )
        )
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(PartyIncomeReport);
